import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const MoneyBackBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showExtendedMessage, setShowExtendedMessage] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  const toggleMessage = () => {
    setShowExtendedMessage(!showExtendedMessage);
  };

  return (
    <div
      className={`
        flex flex-grow-0 sm:hidden h-[50px]
        fixed top-0 left-0 right-0 z-50 
        bg-insightful-purple text-white
        transition-transform duration-500 ease-in-out text-[12px]
        ${isVisible ? "translate-y-0" : "-translate-y-full"}
      `}
    >
      <div
        className="flex justify-center items-center w-full px-2 py-2 cursor-pointer"
        onClick={toggleMessage}
      >
        {!showExtendedMessage ? (
          <div className="flex items-center justify-center w-full">
            <p className="flex items-center text-first-fomo-slide">
              {t("footer.guarantee")}
              <span className="ml-2 inline-block">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  className="transform -rotate-90"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </p>
          </div>
        ) : (
          <div className="flex items-center justify-center w-full">
            <p className="flex items-center text-center text-[12px] px-2">
              <span className="mr-2 inline-block">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  className="transform rotate-90"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              {t("footer.refund_policy_message")}
              {/* If you're unhappy for any reason in the first 30 days, we'll
              refund your money. */}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MoneyBackBanner;
